/* Safe print-a-QR-code utility.
   Avoids document.write() and any HTML-string interpolation of user-supplied
   values (customer name, pump name, URL) so those fields can't inject
   arbitrary script/markup. Only the QR SVG — which is generated by the
   trusted <QRCodeSVG> component from our own state — is copied over as
   an already-serialized SVG node. */
const SHARED_STYLES = `
  body { font-family: system-ui, sans-serif; margin: 0; padding: 40px; text-align: center; color: #111; }
  h1 { font-size: 28px; margin: 0 0 8px; letter-spacing: -0.02em; }
  .tag { font-size: 11px; color: #f57c00; letter-spacing: 3px; text-transform: uppercase; margin-bottom: 24px; }
  .qr { display: inline-block; padding: 16px; border: 2px solid #f57c00; border-radius: 12px; margin: 20px 0; }
  p { color: #666; font-size: 13px; max-width: 480px; margin: 10px auto; }
  .url { font-family: monospace; font-size: 11px; word-break: break-all; color: #444; }
  .footer { margin-top: 40px; font-size: 10px; color: #999; letter-spacing: 2px; text-transform: uppercase; }
`;

export function printQrPage({ title, tagLine, heading, description, footer, url, svgElementId }) {
  const w = window.open("", "_blank");
  if (!w) return;
  const doc = w.document;

  // Build the head safely — title via textContent, static CSS
  doc.title = title || "";
  const style = doc.createElement("style");
  style.textContent = SHARED_STYLES;
  doc.head.appendChild(style);

  // Build the body via DOM APIs so user-supplied strings can't inject markup
  const tagEl = doc.createElement("div");
  tagEl.className = "tag";
  tagEl.textContent = tagLine || "";

  const h1 = doc.createElement("h1");
  h1.textContent = heading || "";

  const desc = doc.createElement("p");
  desc.textContent = description || "";

  const qrWrap = doc.createElement("div");
  qrWrap.className = "qr";
  const srcSvg = document.getElementById(svgElementId);
  if (srcSvg) {
    // Import from the current document; the SVG is generated by <QRCodeSVG>
    // in our own code, so its markup is trusted.
    qrWrap.appendChild(doc.importNode(srcSvg, true));
  }

  const urlEl = doc.createElement("p");
  urlEl.className = "url";
  urlEl.textContent = url || "";

  const footerEl = doc.createElement("div");
  footerEl.className = "footer";
  footerEl.textContent = footer || "";

  [tagEl, h1, desc, qrWrap, urlEl, footerEl].forEach((n) => doc.body.appendChild(n));

  setTimeout(() => { try { w.print(); } catch (_) {} }, 400);
}
